import dayjs from "dayjs";

// Custom Latin Uzbek locale data
export const uzLatnLocaleData = {
  months: [
    "Yanvar",
    "Fevral",
    "Mart",
    "Aprel",
    "May",
    "Iyun",
    "Iyul",
    "Avgust",
    "Sentyabr",
    "Oktyabr",
    "Noyabr",
    "Dekabr",
  ],
  weekdays: ["Dush", "Sesh", "Chor", "Pay", "Jum", "Shan", "Yak"],
  formats: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "YYYY-MM-DD",
    LL: "D MMMM YYYY",
    LLL: "D MMMM YYYY HH:mm",
    LLLL: "dddd, D MMMM YYYY HH:mm",
  },
  relativeTime: {
    future: "Yaqin %s ichida",
    past: "%s avval",
    s: "soniya",
    m: "bir daqiqa",
    mm: "%d daqiqa",
    h: "bir soat",
    hh: "%d soat",
    d: "bir kun",
    dd: "%d kun",
    M: "bir oy",
    MM: "%d oy",
    y: "bir yil",
    yy: "%d yil",
  },
  // Add any additional customizations as needed
};

// Register the custom Latin Uzbek locale
dayjs.locale("uz-latn", uzLatnLocaleData);

// Set the default locale to Latin Uzbek
dayjs.locale("uz-latn");
